import { matchPath } from 'react-router-dom';
export function isRouteMatch(routePath) {
    let isMatch;
    try {
        const { pathname } = window.location;
        isMatch = Boolean(matchPath(pathname, routePath));
    }
    catch (_a) {
        isMatch = false;
    }
    return isMatch;
}
